import { MemberRole } from '@tinct/core-api-models';
import { cn } from '@tinct/core-utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@tinct/web-components';

/** What the `-` option stands for: Radix refuses an empty string as an item value. */
const NO_ROLE = 'none';

export type MemberRoleSelectProps = {
  value: MemberRole | null | undefined;
  onValueChange: (role: MemberRole | null) => void;
  /** Offers `-` first, which hands back `null`: no role at all. */
  allowNone?: boolean;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
};

/**
 * The workspace roles, least to most powerful: the invite form's select, shared with the directory
 * group mapping (which also offers `-`).
 */
export const MemberRoleSelect = ({
  value,
  onValueChange,
  allowNone,
  disabled,
  className,
  'aria-label': ariaLabel,
}: MemberRoleSelectProps) => (
  <Select
    value={value ?? (allowNone ? NO_ROLE : undefined)}
    onValueChange={(next) =>
      onValueChange(next === NO_ROLE ? null : (next as MemberRole))
    }
    disabled={disabled}
  >
    <SelectTrigger className={cn('w-[120px]', className)} aria-label={ariaLabel}>
      <SelectValue placeholder="Role" />
    </SelectTrigger>
    <SelectContent>
      {allowNone && <SelectItem value={NO_ROLE}>-</SelectItem>}
      <SelectItem value="viewer">Viewer</SelectItem>
      <SelectItem value="editor">Editor</SelectItem>
      <SelectItem value="admin">Admin</SelectItem>
    </SelectContent>
  </Select>
);
